import moment from 'moment';

export const TODAY = moment();

export const monthsAgoDate = (months) => moment().subtract(months, 'month').format('YYYY-MM-DD');

export const TWO_MONTHS_AGO = moment().subtract(2, 'months');

export const UNTIL_FIFTEEN_DAYS = moment().add(15, 'days');
